import React, { useEffect, useState } from 'react';
import Button from '../../FlyfishComponents/Button';
import ProductCarousel from './ProductCarousel';
import ImageDisplay from './ImageDisplay';
import ImageDescription from './ImageDescription';
import Variant from './Variant';
import ComplementProducts from './ComplementProducts';
import Axios from 'axios';
import {
	getCurrencySymbol,
	loadStateSession,
} from '../../FlyfishComponents/flyfishutils/utils';

type Props = {
	// handleSubmit: Function;
	// WorkflowData: any;
	colorMode: string;
	colorScale: string;
	productData: any;
	getProductDetails: Function;
	createCart: Function;
	handleSubmit: Function;
	handleSelectedProduct?: Function;
	showComplementary?: Function;
	setProductId?: Function;
	shouldDisableActions?: boolean;
	setProductName?: Function;
	tenantId?: any;
	token?: any;
	// token: any;
	// botId: any;
	// tenantId: any;
	// conversationId: any;
	// cssPtag?: any;
	addUserResponse: Function;
	reasonAPI: any;
	lists: any;
	getProductDescription: Function;
	// currentWorkflow: string;
	// changeScreen?: Function;
	// showToaster?: Function;
	// disableMandatory?: Function;
	// shouldDisableActions?;
};

const ProductDisplayFullScreen = ({
	// handleSubmit,
	// WorkflowData,
	// colorMode,
	// botId,
	// tenantId,
	// token,
	// conversationId,
	// cssPtag,
	// changeScreen,
	addUserResponse,
	// currentWorkflow,
	// showToaster,
	// disableMandatory,
	// shouldDisableActions
	colorMode,
	colorScale,
	productData,
	getProductDetails,
	handleSelectedProduct,
	shouldDisableActions,
	setProductId,
	showComplementary,
	setProductName,
	handleSubmit,
	createCart,
	tenantId,
	token,
	lists,
	reasonAPI,
	getProductDescription,
}: Props) => {
	const [selectedProduct, handleProduct] = useState<any>({});
	const [seeMoreDesc, setSeeMore] = useState(false);
	const [ffstore, setffStore] = useState(null);
	const [reasonAdded, setReason] = useState<any>(null);
	const [reason, getReason] = useState(null);
	const [reasonDesc, setReasonDesc] = useState('');
	const [reasonQuery, setReasonQuery] = useState('');
	// useEffect(() => {
	// 	if (productData.secondAPI === true) {
	// 		Axios.post(
	// 			window['BASE_URL'] + `/messages/product_details`,
	// 			{
	// 				id: productData.id,
	// 				message: productData.message,
	// 				botId: productData.botId,
	// 				version: 'prod',
	// 				country: productData.country,
	// 				metaData: productData.metaData,
	// 			},
	// 			{
	// 				headers: {
	// 					'x-tenant-id': productData.tenantID,
	// 					Authorization: `Bearer ${productData.token}`,
	// 				},
	// 			}
	// 		).then((response) => {
	// 			getReason(response.data.metaData.products);

	// 			let reasonFilter=response.data.metaData.products.filter((item) => {
	// 				return item.product_id === lists[0].productId
	// 			});
	// 			setReasonQuery(reasonFilter && reasonFilter[0].reason_query);
	// 			setReasonDesc(reasonFilter && reasonFilter[0].reason)

	// 		});
	// 	} else {
	// 		setReason(false);
	// 	}
	// }, []);
	const handleProductDetails = (productId) => {

		Axios.get(
			window['BASE_URL'] + `/conversation/tenant/${tenantId}/bot/${productData.botId}/recommendation_rational?text=${productData.message}&conversation_id=${productData.id}&message_id=${productData.messageId}&productId=${productId}`,
			{
				headers: {
					'Authorization': `Bearer ${loadStateSession('token')}`,
					'x-tenant-id': loadStateSession('tenantId') || loadStateSession('tenantID')
				}
			}

		).then((response) => {
			setReason(true);
			setReasonQuery('');
			setReasonDesc(response.data.products[0].reason)
		});
	};
	useEffect(() => {
		Axios.get(
			`${window['BASE_URL']}/shop/${tenantId}/product?productId=${lists[0].productId
			}&country=${loadStateSession('FS-countryCode')}`,
			{
				headers: {
					'x-tenant-id': tenantId,
					Authorization: `Bearer ${token}`,
				},
			}
		).then((resp: any) => {
			let response = resp.data.response;
			if (resp.data.response.serviceType === 'FFStore') {
				setffStore(true);
			} else {
				setffStore(false);
			}

			response = handleProduct(response);
		});
		handleSelectedProduct({
			productID: lists[0].productId,
			productName: lists[0].title,
		});
		handleProductDetails(lists[0].productId)

	}, []);

	// useEffect(() => {
	// 	if (reason && reason.length > 0) {
	// 		setReason(true);
	// 	} else {
	// 		if (reason !== null) setReason(false);
	// 	}
	// }, [reason]);
	const selectProduct = (productId, productname) => {
		Axios.get(
			`${window['BASE_URL']
			}/shop/${tenantId}/product?productId=${productId}&country=${loadStateSession(
				'FS-countryCode'
			)}`,
			{
				headers: {
					'x-tenant-id': tenantId,
					Authorization: `Bearer ${token}`,
				},
			}
		).then((resp: any) => {
			let response = resp.data.response;
			if (response.serviceType === 'FFStore') {
				setffStore(true);
			} else {
				setffStore(false);
			}
			response = handleProduct(response);

		});
		// let reasonFilter = reason.filter((item) => {
		// 	return item.product_id === productId
		// });
		// setReasonQuery(reasonFilter && reasonFilter[0].reason_query);
		// setReasonDesc(reasonFilter && reasonFilter[0].reason)
		handleSelectedProduct({ productID: productId, productName: productname });
		handleProductDetails(productId)
	};
	const [selectedIndex, handleSelected] = useState(0);
	const displaySymbol = (currencyCode) => {
		return <>{getCurrencySymbol(currencyCode)}</>;
	};

	return (
		<div
			className='ff-productDisplay-content'
			style={{
				pointerEvents: shouldDisableActions ? 'none' : 'initial',
				opacity: shouldDisableActions ? '0.5' : '1',
			}}
		>
			<div className='ff-carousel-border'></div>
			<div
				className={`ff-productDisplay-right ${lists[selectedIndex] &&
					Object.keys(lists[selectedIndex].complimentary_product).length === 0
					? 'ff-no-complementary'
					: ''
					}`}
			>
				{lists.length > 1 && (
					<>
						<ProductCarousel
							token={token}
							tenantId={tenantId}
							colorMode={colorMode}
							colorScale={colorScale}
							data={lists}
							selectProduct={selectProduct}
							handleSelected={(index) => {
								handleSelected(index);
							}}
						/>
						<div className='ff-carousel-border-bottom'></div>
					</>
				)}

				<div className='ff-product-display-desc-cart'>
					<div className='ff-product-image-desc'>
						<ImageDisplay
							images={
								selectedProduct.data && selectedProduct.data.variants[0].image
							}
							title={lists[selectedIndex].title}
							isReason={
								lists[selectedIndex] && reasonAdded
									? true
									: reasonAdded == false
										? false
										: null
							}
							ffstore={false}
						/>
						{lists[selectedIndex] && reasonAdded == true && (
							<div>
								<div className='ff-related-image-price'>
									{selectedProduct.data &&
										selectedProduct.data.variants.length > 0 &&
										selectedProduct.data.variants[0].price !== '0' &&
										displaySymbol(
											selectedProduct.data.variants[0].currency
										)}{' '}
									{selectedProduct.data &&
										selectedProduct.data.variants[0].price !== '0' &&
										selectedProduct.data.variants[0].price}
								</div>
							</div>
						)}
					</div>

					<div className={`ff-cart-desc ${colorMode}`}>
						{lists[selectedIndex] && reasonAdded === false ? (
							<div>
								<div
									className='ff-cart-desc-title'
									dangerouslySetInnerHTML={{
										__html:
											selectedProduct &&
											selectedProduct.data &&
											selectedProduct.data.title.replace(/\n/g, '<br />'),
									}}
								></div>

								<div className='ff-related-image-price'>
									{selectedProduct &&
										selectedProduct.data &&
										selectedProduct.data.variants.length > 0 &&
										selectedProduct.data.variants[0].price !== '0' &&
										displaySymbol(
											selectedProduct.data.variants[0].currency
										)}{' '}
									{selectedProduct.data &&
										selectedProduct.data.variants[0].price !== '0' &&
										selectedProduct.data.variants[0].price}
								</div>

								<div className='ff-cart-desc-cnt'>
									<div
										className={`ff-product-image-related-content-title ${colorMode}`}
									>
										Description
									</div>
									<ImageDescription
										title=''
										price=''
										currencyCode={
											selectedProduct.data &&
											selectedProduct.data.variants[0].currency
										}
										desc={
											selectedProduct.data && selectedProduct.data.description
										}
									/>
								</div>
							</div>
						) : reasonAdded == true ? (
							<div className='ff-cart-desc-content'>
								<div
									className='ff-reason-query'
								> {`Why do we recommend ${selectedProduct.data.title}?`}</div>
								<div
									dangerouslySetInnerHTML={{
										__html:
											reasonDesc.replace(/\n/g, '<br />'),
									}}
								></div>
								<>
									<div
										className={`ff-product-image-related-content-title ${colorMode}`}
									>
										Description
									</div>
									<ImageDescription
										title={selectedProduct.data && selectedProduct.data.title}
										price={
											selectedProduct.data &&
											selectedProduct.data.variants[0].price
										}
										currencyCode={
											selectedProduct.data &&
											selectedProduct.data.variants[0].currency
										}
										desc={
											selectedProduct.data && selectedProduct.data.description
										}
									/>
								</>
							</div>
						) : null}
						{selectedProduct.data &&
							selectedProduct.data.variants[0].price &&
							selectedProduct.data.variants[0].price !== '0' && (
								<Button
									buttonType={colorMode == 'dark' ? 'dark' : 'light'}
									onClick={() => {
										//createCart(selectedProduct.data.product.variants[0].admin_graphql_api_id,)
									}}
								>
									Add to Cart
								</Button>
							)}

						<Variant colorMode={colorMode} />
						<div className='ff-protection-plans'></div>
					</div>
				</div>
			</div>
			{lists[selectedIndex] &&
				lists[selectedIndex].complimentary_product.length > 0 && (
					<div className='ff-productDisplay-left'>
						<ComplementProducts
							handleSubmit={(id?, name?) => {
								setProductId(id);
								showComplementary();
								setProductName(name);
							}}
							complementary={
								lists[selectedIndex] &&
								lists[selectedIndex].complimentary_product
							}
						/>
					</div>
				)}
		</div>
	);
};

export default ProductDisplayFullScreen;
